import { Input } from 'antd';
import styled, { css } from 'styled-components';
import { TabContainer, TabRow } from '../Tabs-styled';


export const StyledTextInput = styled(Input)`
  position: relative;

	border: unset;
	border-radius: unset;
	box-shadow: unset;
	padding: unset;
  margin: 3px;
  box-sizing: border-box;
	
	border: 1px solid ${(props) => props.theme.colors.darkGray};

  height: 50px;
	
	font-weight: 500;
	font-size: 22px; 
	line-height: 25px;

  text-indent: 12px;

  &:hover, &:focus {
		border-color: unset;
		box-shadow: unset;
	};
`;

export const MaxCharacterWarning = styled.span<{highlight?:boolean}>`
	${(props) => props.highlight && css`
    color: ${(props) => props.theme.colors.red};
  `};
`;

export const SymbolContainer = styled.div`
  display: flex;
  flex-basis: 100%;
  margin: 3px;
  align-items: center;
  justify-content: center;
  min-height: 50px;
  border: 1px solid ${(props) => props.theme.colors.darkGray};
  cursor: pointer;

  & .svg-wrapper {
    text-align: center;
  }
`;

export const FontOptionContainer = styled.div<{isSelected:boolean}>`
  display: flex;
  flex-basis: 100%;
  margin: 3px;
  align-items: center;
  justify-content: center;
  min-height: 50px;
  border: 1px solid ${(props) => props.theme.colors.darkGray};
  cursor: pointer;
  font-size: 20px;

  ${(props) => props.isSelected && css`
    border-color: ${(props) => props.theme.colors.backgroundBlack};
  `};
`;

export const TypeFaceTabRow = styled(TabRow)`
  margin-top: 30px;
`;

export const EngravingTabContainer = styled(TabContainer)`
  ${(props) => props.mobile && css`
		${StyledTextInput} {
			height: ${40 * props.menuScaleFactor}px;
			font-size: ${14 * props.menuScaleFactor}px;
			line-height: ${16 * props.menuScaleFactor}px;
			text-indent: ${9 * props.menuScaleFactor}px;
		};

    ${SymbolContainer} {
      min-height: ${40 * props.menuScaleFactor}px;
    };

    ${FontOptionContainer} {
      min-height: ${40 * props.menuScaleFactor}px;
      font-size: ${14 * props.menuScaleFactor}px;
    };
  `};
`; 